import { render, staticRenderFns } from "./qSelect.vue?vue&type=template&id=79440c16&scoped=true&"
import script from "./qSelect.vue?vue&type=script&lang=ts&"
export * from "./qSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79440c16",
  null
  
)

export default component.exports